import { Breadcrumbs, Link } from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";

const BreadcrumbPurchase = ({
  productName,
  principalName,
  isConfirmCheckout,
}) => {
  const navigate = useNavigate();
  const { search } = useLocation();
  const fromStatus = new URLSearchParams(search).get("from");
  const listTransactionPath =
    fromStatus !== null
      ? `/purchase-pbf/list-transaction/${fromStatus}`
      : "/purchase-pbf/list-transaction/0";

  return (
    <div className="text-[12px] text-[#2C3E5D]">
      <Breadcrumbs
        sx={{ color: "#2C3E5D" }}
        aria-label="breadcrumb"
        separator={<NavigateNextIcon fontSize="small" />}
      >
        <Link
          underline="hover"
          color="inherit"
          href="/purchase-pbf"
          onClick={() => navigate("/purchase-pbf")}
        >
          Home
        </Link>
        {window.location.pathname.includes("/purchase-pbf/product-list/all") ? (
          <Link
            underline="hover"
            color="inherit"
            href="/purchase-pbf/product-list/all"
            onClick={() => navigate("/purchase-pbf/product-list/all")}
          >
            Semua Produk
          </Link>
        ) : null}
        {window.location.pathname.includes(
          "/purchase-pbf/product-list/special-offer",
        ) ? (
          <Link
            underline="hover"
            color="inherit"
            href="/purchase-pbf/product-list/special-offer"
            onClick={() => navigate("/purchase-pbf/product-list/special-offer")}
          >
            Penawaran Special
          </Link>
        ) : null}
        {window.location.pathname.includes(
          "/purchase-pbf/product-list/most-search",
        ) ? (
          <Link
            underline="hover"
            color="inherit"
            href="/purchase-pbf/product-list/most-search"
            onClick={() => navigate("/purchase-pbf/product-list/most-search")}
          >
            Paling Banyak Dicari
          </Link>
        ) : null}
        {window.location.pathname.includes(
          "/purchase-pbf/product-list/recent-search",
        ) ? (
          <Link
            underline="hover"
            color="inherit"
            href="/purchase-pbf/product-list/recent-search"
            onClick={() => navigate("/purchase-pbf/product-list/recent-search")}
          >
            Berdasarkan Pencarianmu
          </Link>
        ) : null}
        {window.location.pathname.includes(
          "/purchase-pbf/product-list/keyword=",
        ) ? (
          <Link
            underline="hover"
            color="inherit"
            href="/purchase-pbf/product-list/keyword="
            onClick={() => navigate("/purchase-pbf/product-list/keyword=")}
          >
            Pencarian
          </Link>
        ) : null}
        {window.location.pathname.includes("/principal") ? (
          <Link
            underline="hover"
            color="inherit"
            href="/purchase-pbf/principal"
            onClick={() => navigate("/purchase-pbf/principal")}
          >
            Principal
          </Link>
        ) : null}
        {window.location.pathname.includes(
          "/purchase-pbf/product-list/principal/",
        ) && principalName ? (
          <Link underline="none" color="inherit">
            {principalName}
          </Link>
        ) : null}
        {window.location.pathname.includes("/purchase-pbf/detail-product/") &&
        productName ? (
          <Link underline="none" color="inherit">
            {productName}
          </Link>
        ) : null}
        {window.location.pathname.includes("/purchase-pbf/cart") ? (
          <Link
            underline="hover"
            color="inherit"
            href="/purchase-pbf/cart"
            onClick={() => navigate("/purchase-pbf/cart")}
          >
            Keranjang Belanja
          </Link>
        ) : null}
        {window.location.pathname.includes("/purchase-pbf/checkout") ? (
          <Link color="inherit" underline="none">
            {isConfirmCheckout ? "Konfirmasi Pembayaran" : "Checkout"}
          </Link>
        ) : null}
        {window.location.pathname.includes("/purchase-pbf/confirm-checkout") ? (
          <Link color="inherit" underline="none">
            Konfirmasi Pembayaran
          </Link>
        ) : null}
        {window.location.pathname.includes("/purchase-pbf/success-payment/") ? (
          <Link color="inherit" underline="none">
            Pembayaran Berhasil
          </Link>
        ) : null}
        {window.location.pathname.includes("/purchase-pbf/activate-amanah") ? (
          <Link
            color="inherit"
            href="/purchase-pbf/activate-amanah"
            onClick={() => navigate("/purchase-pbf/activate-amanah")}
            underline="none"
          >
            Aktivasi Olin Amanah
          </Link>
        ) : null}
        {window.location.pathname.includes("/purchase-pbf/confirm-amanah") ? (
          <Link
            color="inherit"
            href="/purchase-pbf/confirm-amanah"
            onClick={() => navigate("/purchase-pbf/confirm-amanah")}
            underline="none"
          >
            Aktivasi Olin Amanah
          </Link>
        ) : null}
        {window.location.pathname.includes("/purchase-pbf/list-transaction") ||
        window.location.pathname.includes(
          "/purchase-pbf/detail-transaction",
        ) ? (
          <Link
            color="inherit"
            href={listTransactionPath}
            onClick={(e) => {
              e.preventDefault();
              navigate(listTransactionPath);
            }}
            underline="hover"
          >
            Daftar Pesanan
          </Link>
        ) : null}
        {window.location.pathname.includes(
          "/purchase-pbf/detail-transaction",
        ) ? (
          <Link color="inherit" underline="none">
            Detail Pesanan
          </Link>
        ) : null}
        {window.location.pathname.includes("/purchase-pbf/complaint") ? (
          <Link color="inherit" underline="none">
            Ajukan Komplain
          </Link>
        ) : null}
      </Breadcrumbs>
    </div>
  );
};

export default BreadcrumbPurchase;
